module.exports = __webpack_public_path__ + "img/tarj2-2.8959ba8a.png";